module.exports = __webpack_public_path__ + "static/img/08013B_1_2_C_20220510_fit.ac17ac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08013B_1_2_C_20220510_fit.png
// module id = GFl8
// module chunks = 0